import { useTheme } from '@mui/material';

export const RealWorldEvidenceIcon = () => {
    const theme = useTheme();
    const {
        stroke: { primary: primaryStroke },
    } = theme.colors.other.icon;

    return (
        <svg xmlns="http://www.w3.org/2000/svg" width={48} height={48} fill="none">
            <path fill={primaryStroke} d="M7 8.893v29.65h33.25v2H5V8.893h2Z" />
            <path
                fill={primaryStroke}
                d="M24.064 24.343 18.5 29.908l-3.25-3.25-5.2 5.2-1.414-1.415 6.614-6.614 3.25 3.25 4.15-4.15 1.414 1.414Zm4.62-5.181 6.01-6.01-1.414-1.414-6.01 6.01 1.414 1.414Z"
            />
            <path
                fill={primaryStroke}
                fillRule="evenodd"
                d="M36.957 9.475a8.452 8.452 0 0 1 .665 11.202l4.886 4.885-1.415 1.414-4.885-4.885A8.451 8.451 0 0 1 25.007 9.475a8.45 8.45 0 0 1 11.95 0Zm-1.415 1.414a6.45 6.45 0 1 1-9.12 9.122 6.45 6.45 0 0 1 9.12-9.122Z"
                clipRule="evenodd"
            />
        </svg>
    );
};
